import { AxiosResponse } from "axios"
import { RaceTypes } from '../enums/RaceTypes'
import { AuthResponse } from "../models/response/AuthResponse"
import { NuiCallbacks } from '../utils/ClientEvents'
import { api } from './api'
import { ClientApi } from './clientApi'

export interface LastVehicleData {
    vehicleId: number
}

export interface LastChoseActivityData {
    activity: RaceTypes
}

export default class PlayerService {

    static async runFreeroomCommon(vehicleId: number): Promise<AxiosResponse<AuthResponse>> {
        return api.post<AuthResponse>('/freeroom/run/common', { vehicleId })
    }

    static async showCursor(): Promise<AxiosResponse<void>> {
        return api.post<void>('/user/cursor/toggle', { id: -1, enabled: true })
    }

    static async hideCursor(): Promise<AxiosResponse<void>> {
        return api.post<void>('/user/cursor/toggle', { id: -1, enabled: false })
    }

    static async tryFetchLastVehicleFromClient() {
        const data = await ClientApi.request<LastVehicleData>(
            NuiCallbacks.FETCH_LAST_VEHICLE,
            {}
        )

        if (data) {
            localStorage.setItem('vehicleId', String(data.vehicleId))
            return data
        }

        return null
    }

    static async trySaveLastVehicleToClient(vehicleId: number) {
        await ClientApi.request<void>(
            NuiCallbacks.SAVE_LAST_VEHICLE,
            { vehicleId }
        )
    }

    static async trySaveLastChosenActivity(activity: RaceTypes) {
        await ClientApi.request<void>(
            NuiCallbacks.SAVE_LAST_CHOSEN_ACTIVITY,
            { activity }
        )
    }

    static async tryFetchLastChosenActivityFromClient() {
        const data = await ClientApi.request<LastChoseActivityData>(
            NuiCallbacks.FETCH_LAST_CHOSEN_ACTIVITY,
            {}
        )

        if (data) {
            localStorage.setItem('lastChosenActivity', String(data.activity))
            return data
        }

        return null
    }
} 